export default __webpack_public_path__ + "static/media/logoeie.c9358c50.png";